$(() => {
  //Apply select2 default configs
  Object.entries(CONSTANTS.SELECT2_DEFAULTS).forEach(([key, value]) => $.fn.select2.defaults.set(key, value));

  $("body").on("keyup", ".select2-search__field", function () {
    let stringVal = $(".select2-search__field");
    stringVal.val(stringVal.val().replace(/^\s+/g, ""));
  });

  // ----------------------------
  modalSelect($(".student_teacher"));
  modalSelect($(".teacher_failed"));
  modalSelect($(".missing-shortcuts"));

  function modalSelect(elem) {
    elem.each(function () {
      let el = "#" + $(this).attr("id"),
        modalBody = $(el).parent();

      $(this).select2({
        dropdownParent: modalBody,
      });
    });
  }
});

$(document).on("ajax:complete", () => window._hyperscript?.browserInit());

// Patch $.fn.serializeArray to include custom form-associated elements (e.g. <x-select>)
// that use ElementInternals.setFormValue() to contribute via FormData but are invisible
// to jQuery's standard serialization, which only walks standard form controls.
;(function ($) {
  const _serializeArray = $.fn.serializeArray;
  $.fn.serializeArray = function () {
    const el = this[0];
    if (el instanceof HTMLFormElement) {
      return Array.from(new FormData(el))
        .filter(([, v]) => !(v instanceof File))
        .map(([name, value]) => ({ name, value: String(value) }));
    }
    return _serializeArray.call(this);
  };
})(jQuery);
